import React from "react";


import "./About.css";
import AboutContent from './aboutcontent/AboutContent';
import AboutBanner from './aboutbanner/AboutBanner';
import InfoCards from './infocards/InfoCards';
import SpirulinaCommunitySteps from './spirulinacommunitysteps/SpirulinaCommunitySteps';
import ShareholderOpportunity from './shareholderopportunity/ShareholderOpportunity';
import SpirulinaLevels from './spirulinalevels/SpirulinaLevels';

const About = () => {
  return (
    <div className="about-page">
      <AboutBanner />
      <AboutContent />

      <InfoCards />

      <SpirulinaCommunitySteps/>

      <ShareholderOpportunity/>
      <SpirulinaLevels/>
    </div>
  );
};

export default About;
